import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-price-details" }
const _hoisted_2 = { class: "product-price-details__prices" }
const _hoisted_3 = { class: "fs-regular" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "d-none d-print-inline" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "product-price-details__downloads" }
const _hoisted_8 = ["href"]

import {
  computed,
  ref,
  onMounted,
} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDownload,
  faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';
import Product from '@/classes/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceDetailsTable',
  props: {
    product: {}
  },
  emits: ['subs'],
  setup(__props: any, { emit: __emit }) {

library.add(faInfoCircle, faDownload);

const emit = __emit;
const props = __props;

const countSub = ref(1);

const rowsPrices = computed(() => {
  const rows: Record<any, unknown>[] = [];

  if (props.product.priceIsDouble) {
    rows.push({
      label: 'Arbeitspreis HT (brutto)',
      value: `${props.product.getPriceFormatted('workingPriceHt')}&thinsp;Cent/kWh`,
    });
    rows.push({
      label: 'Arbeitspreis NT (brutto)',
      value: `${props.product.getPriceFormatted('workingPriceNt')}&thinsp;Cent/kWh`,
    });
  } else if (props.product.attributes.details.customerType === 'business') {
    rows.push({
      label: 'Arbeitspreis (netto) ',
      value: `${props.product.getPriceFormatted('workingPrice')}&thinsp;Cent/kWh`,
    });
  } else {
    rows.push({
      label: 'Arbeitspreis (brutto) ',
      value: `${props.product.getPriceFormatted('workingPrice')}&thinsp;Cent/kWh`,
    });
  }

  if (props.product.attributes.details.customerType === 'business') {
    rows.push({
      label: 'Grundpreis (netto)',
      value: `${props.product.getPriceFormatted('basePrice')}&thinsp;€/Monat`,
    });
  } else {
    rows.push({
      label: 'Grundpreis (brutto)',
      value: `${props.product.getPriceFormatted('basePrice')}&thinsp;€/Monat`,
    });
  }

  props.product.bonuses.forEach((bonus) => {
    rows.push({
      label: bonus.label,
      value: `${bonus.valueGrossFormatted}&thinsp;€`,
      info: bonus.description,
      sub: countSub.value,
    });

    countSub.value += 1;
  });

  rows.push({
    label: 'Kosten im 1. Jahr',
    value: `${props.product.getPriceFormatted('yearly')}&thinsp;€`,
  });

  rows.push({
    label: 'Vertragslaufzeit',
    value: `${props.product.contractTermLabel}`,
  });

  rows.push({
    label: 'Kündigungsfrist',
    value: `${props.product.noticePeriodLabel}`,
  });

  return rows;
});

const rowsDownloads = computed(() => {
  const rows: Record<'label' | 'href' | 'key', string>[] = [];

  /*
  if (props.product.priceFileUrl) {
    rows.push({
      key: 'pricefile',
      label: 'Preisblatt',
      href: props.product.priceFileUrl,
    });
  }
   */

  const agbDocument = props.product.getDocumentByKey('agb');
  if (agbDocument) {
    rows.push({
      key: agbDocument.key,
      label: agbDocument.name || '',
      href: agbDocument.url || '#',
    });
  }

  const avbDocument = props.product.getDocumentByKey('avb');
  if (avbDocument) {
    rows.push({
      key: avbDocument.key,
      label: avbDocument.name || '',
      href: avbDocument.url || '#',
    });
  }

  const bgbDocument = props.product.getDocumentByKey('bgb');
  if (bgbDocument) {
    rows.push({
      key: bgbDocument.key,
      label: bgbDocument.name || '',
      href: bgbDocument.url || '#',
    });
  }

  return rows;
});

onMounted(() => {
  const subs: { sub: number, info: string }[] = [];

  rowsPrices.value.forEach((row) => {
    if (row.info && row.sub) {
      subs.push({ sub: row.sub as number, info: row.info as string });
    }
  });

  emit('subs', subs);
});


return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsPrices.value, (row) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: row.label
        }, [
          _createElementVNode("td", _hoisted_3, [
            _createElementVNode("span", {
              innerHTML: row.label
            }, null, 8, _hoisted_4),
            _createElementVNode("sup", _hoisted_5, _toDisplayString(row.sub), 1),
            _createTextVNode("  "),
            (row.info)
              ? (_openBlock(), _createBlock(_component_IoTooltip, {
                  key: 0,
                  class: "d-print-none"
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.info), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, { icon: _unref(faInfoCircle) }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", {
            class: "fs-regular",
            innerHTML: row.value
          }, null, 8, _hoisted_6)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsDownloads.value, (row) => {
        return (_openBlock(), _createElementBlock("a", {
          key: `download--${row.key}`,
          href: row.href,
          target: "_blank"
        }, [
          _createElementVNode("span", null, [
            _createVNode(_component_FontAwesomeIcon, { icon: _unref(faDownload) }, null, 8, ["icon"])
          ]),
          _createElementVNode("span", null, _toDisplayString(row.label), 1)
        ], 8, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

})